import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useNavigate, useOutletContext } from "react-router-dom";
import useTranslation from "util/useTranslate";

const JoinGameModal = ({ sessionId, onHide }) => {
  const [name, setName] = useState("");

  const translate = useTranslation();
  const navigate = useNavigate();
  const { updateState } = useOutletContext();

  const handleSubmit = (event) => {
    event.preventDefault();

    updateState({
      name,
      team: null,
      ready: false,
    })
      
    navigate(`/lobby/${sessionId}`);
  };

  const disabled = !name;

  return (
    <Modal show={!!sessionId} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{translate("joinGame")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="playerName">
            <Form.Label>{translate("enterName")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={translate("name")}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button disabled={disabled} variant="primary" type="submit">
            {translate("joinGame")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default JoinGameModal;
